import { useI18n } from "vue-i18n";

/* 2100-01-01T00:00:00.000000Z to 2100-01-01 (depends on locale) */
export const formatDate = (date: string): string => {
  const { locale } = useI18n();
  const dateObj = new Date(date);
  return dateObj.toLocaleDateString(locale.value, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};
